import { Injectable } from '@angular/core';
import { AppBridge } from 'novo-elements';
import { EntityTypes } from '@bullhorn/bullhorn-types';
import { AppBridgeMspService } from './appBridgeMsp.service';
import { SearchResponse } from '../interfaces/bullhorn';
import { Where } from '@bullhorn/taurus';

@Injectable()
export class HttpMspService {
  private MAX_RECORDS_TO_RETURN = 500;

  constructor(private appBridgeService: AppBridgeMspService) {}

  static handleAppBridgeResponse(response: any, resolve: (any) => void, reject: (any) => void): void {
    if (!response) {
      reject(response);
    } else if (response.error) {
      reject(response.error);
    } else if (response.data) {
      resolve(response.data);
    } else {
      resolve(response);
    }
  }

  getEntity(entityType: EntityTypes, entityId: number, fields: string = '*', meta: string = 'off'): Promise<any> {
    return new Promise((resolve, reject) => {
      this.appBridgeService.execute((appBridge: AppBridge) => {
        appBridge.httpGET(`entity/${entityType}/${entityId}?fields=${fields}&meta=${meta}`).then((response: any) => {
          HttpMspService.handleAppBridgeResponse(response, resolve, reject);
        }).catch((error: Error) => {
          reject(error);
        });
      });
    });
  }
} 